import { createTheme } from '@mui/material/styles';
// https://material-ui.com/customization/default-theme/ aca aparecen los nombres del theme que vienen por defecto para poder cambiarlos

export default createTheme({
    palette: {
        primary: {
            main: '#00BCD4',
            contrastText: '#FFF'
        },
        secondary: {
            main: '#F2994A',
            contrastText: '#FFF',
        },
        error: {
            main: '#ef6b6b',
            contrastText: '#FFF',
        },
        info: {
            main: '#337ab7',
        }
    }
});